<script lang="ts">
  import { type Snippet } from 'svelte'
  import Navbar from '../navbar/Navbar.svelte'
  import Footer from '../footer/Footer.svelte'

  type Props = {
    children?: Snippet
  }

  let { children }: Props = $props()
</script>

<div class="main-container">
  <Navbar />
  <div class="content">
    {@render children?.()}
  </div>
</div>
<Footer />

<style lang="scss">
  .main-container {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    min-height: 100vh;

    .content {
      display: flex;
      flex-direction: column;
      gap: 1rem;
      margin: 0 auto;
      max-width: 1216px;
      padding: 2rem 1rem;
      width: 100%;
    }
  }
</style>
